import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export interface ChatbotWidgetInitResponse {
  _id: string;
  name: string;
  welcomeTitle: string;
  welcomeMessage: string;
  logo?: string;
  primaryColor?: string;
  secondaryColor?: string;
  textColor?: string;
  size?: 'small' | 'medium' | 'large';
  windowStyle?: 'floating' | 'full';
  questionList?: string[];
  inputPlaceholder?: string;
  dataCollection?: Array<{
    _id: string;
    name: string;
    label: string;
    type: string;
    required: boolean;
    placeholder?: string;
  }>;
  conversationId: string | null;
  messages: any[];
  dataCompletionCompleted: boolean;
  conversationStatus: 'bot_active' | 'pending_agent' | 'agent_active' | 'closed';
}

export const chatbotWidgetService = {
  async initialize(botId: string, visitorId: string): Promise<ChatbotWidgetInitResponse> {
    const response = await axios.get(`${API_URL}/widget/chatbot/init`, {
      params: { botId, visitorId }
    });
    return response.data.data;
  },

  async startConversation(chatbotId: string, visitorId: string) {
    const response = await axios.post(`${API_URL}/widget/chatbot/start-conversation`, {
      chatbotId,
      visitorId
    });
    return response.data.data;
  },

  async sendMessage(
    conversationId: string | null,
    visitorId: string,
    botId: string,
    message: {
      type: 'button' | 'list' | 'list_reply' | 'media_button' | 'question' | 'media_question' | 'text' | 'ask_address' | 'ask_location' | 'location' | 'media';
      text?: string;
      buttonId?: string;
      buttonLabel?: string;
      listItemId?: string;
      itemTitle?: string;
      itemId?: string;
      address?: string;
      latitude?: number;
      longitude?: number;
      location?: { latitude: number; longitude: number; name?: string; address?: string };
      media?: { url: string; mimeType: string; caption?: string };
    }
  ) {
    const response = await axios.post(`${API_URL}/widget/messages`, {
      conversationId,
      visitorId,
      botId,
      message
    });
    return response.data.data;
  },

  async submitDataCollection(chatBotId: string, data: { visitorId: string, collectedData: Record<string, unknown> }) {
    const response = await axios.post(`${API_URL}/widget/chatbot/${chatBotId}/data-collection/submit`, data);
    return response.data.data;
  },

  async uploadMedia(file: File, visitorId: string, chatbotId: string, conversationId?: string | null) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('visitorId', visitorId);
    formData.append('chatbotId', chatbotId);
    if (conversationId) {
      formData.append('conversationId', conversationId);
    }

    const response = await axios.post(`${API_URL}/widget/chatbot/upload-media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.data;
  }
};
